import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { useLocation } from 'react-router-dom';

import { getAssignmentById } from '../../actions/assignment';
import { setGoogleCourseWorkId } from '../../actions/application';
import { getStatusById } from '../../actions/status';
import ClassworkPreview from '../../components/classwork-preview';
import ClassWorkLoginCorrectionComponent from '../../components/classwork-login-correction-component';
import { requestAccessToken, resumeGoogleLogin } from '../../actions/google-auth';

const ClassWorkCorrectionPage = ({
    assignment,
    getAssignmentById,
    status,
    getStatusById,
    googleUserInfo,
    googleUserStatus,
    requestAccessToken,
    resumeGoogleLogin,
    setGoogleCourseWorkId,
}) => {
    const isGooglePreview = navigator.userAgent.includes('Google Web Preview');

    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    let assignmentId = searchParams.get('aid');
    let statusId = searchParams.get('sid');

    if (!assignmentId && !statusId) {
        // entrambe non impostate
        assignmentId = sessionStorage.getItem('aid');
        statusId = sessionStorage.getItem('sid');
    } else if (assignmentId && statusId) {
        //entrambe impostate nel url
        sessionStorage.setItem('aid', assignmentId);
        sessionStorage.setItem('sid', statusId);
    }

    return !isGooglePreview ? (
        <ClassWorkLoginCorrectionComponent
            assignment={assignment}
            assignmentId={assignmentId}
            getAssignmentById={getAssignmentById}
            googleUserInfo={googleUserInfo}
            googleUserStatus={googleUserStatus}
            requestAccessToken={requestAccessToken}
            resumeGoogleLogin={resumeGoogleLogin}
            status={status}
            statusId={statusId}
            getStatusById={getStatusById}
            setGoogleCourseWorkId={setGoogleCourseWorkId}
        />
    ) : (
        <ClassworkPreview assignment={assignment} assignmentId={assignmentId} getAssignmentById={getAssignmentById} />
    );
};

ClassWorkCorrectionPage.propTypes = {
    assignment: PropTypes.object,
    status: PropTypes.object,
    getAssignmentById: PropTypes.func,
    googleUserInfo: PropTypes.object,
    googleUserStatus: PropTypes.shape({
        error: PropTypes.bool,
        pending: PropTypes.bool,
        success: PropTypes.bool,
    }),
    requestAccessToken: PropTypes.func,
    resumeGoogleLogin: PropTypes.func,
    setGoogleCourseWorkId: PropTypes.func,
    getStatusById: PropTypes.func,
};

function mapStateToProps(state) {
    return {
        assignment: state.assignment,
        status: state.status,
        googleUserInfo: state.googleAuth.userInfo,
        googleUserStatus: state.googleAuth.status,
    };
}

const actionCreators = {
    getAssignmentById,
    getStatusById,
    requestAccessToken,
    resumeGoogleLogin,
    setGoogleCourseWorkId,
};

export default connect(mapStateToProps, actionCreators)(ClassWorkCorrectionPage);
